export const queryKeys = {
  productInfo: ["tizen", "product-info"] as const,
};
